<template>
  <div id="app" @click.stop="isTimeOut">
    <router-view v-if="isReload" />
  </div>
</template>

<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  
  data() { 
    return {
       timeOut: '',
       bAntiShike:false,
       isReload: true
    }; 
  }, 
  created(){ 
    this.isTimeOut();
  },
  mounted(){
    let isMobile = false ;
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        /*window.location.href="你的手机版地址";*/
        isMobile = true ;
    }else {
        /*window.location.href="你的电脑版地址";    */
        isMobile = false ;
    }
    this.$store.commit('isMobile',isMobile);
    localStorage.setItem('isMobile',isMobile);
    // window.onresize = () => {
    //   if (!this.bAntiShike) {
    //     this.bAntiShike = true ;
    //     console.log(document.documentElement.clientWidth,'document.documentElement.clientWidth')
    //     setTimeout(() => {
    //       if(document.documentElement.clientWidth<1440){
		//           // var bodyWidth = this.setBodyWidth()+"px" ;
    //           // doucumnet.body.style.width = bodyWidth ;
    //           if(document.documentElement.clientWidth<860){
    //             this.$message.warning('当前窗口太小,不利于观看,请放大后操作。')
    //           }
    //       }
    //       this.bAntiShike = false
    //     }, 300)
    //   }
    // }
    
    // 监听浏览器刷新
    // let that = this ;
    // console.log("浏览器刷新 || 关闭了5555");
    // window.addEventListener( "unload", that.browerStatus() );
  },
  
  methods: { 
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    },
    setBodyWidth(){
      var barWidthHelper=document.createElement('div');
      barWidthHelper.style.cssText="overflow:scroll; width:100px; height:100px;";
      document.body.appendChild(barWidthHelper);
      var barWidth=barWidthHelper.offsetWidth-barWidthHelper.clientWidth;
      document.body.removeChild(barWidthHelper);
      var bodyWidth=window.screen.availWidth-barWidth;
      return bodyWidth;
    },
    throttle(fn, wait) { 
      // 节流throttle代码(时间戳+定时器) 
      var timer = null; // 定义一个变量来 储存定时器 
      var startTime = Date.now(); // 存开始时间
      return function() { 
          var curTime = Date.now(); // 存现在时间 
          var remaining = wait - (curTime - startTime); 
          var context = this;
          var args = arguments;
          clearTimeout(timer); 
          if (remaining <= 0) { 
              fn.apply(context, args);
              startTime = Date.now();
          } else { 
              timer = setTimeout(fn, remaining); 
          } 
      } 
    }, 
    handle() {
      localStorage.removeItem("backFlag")
      clearInterval(this.timeOut); // console.log(Math.random()); log.info('========>','我清除了吗？') 
      if (this.$route.path == '/login' || this.$route.path == '/wxLogin') {
          return;
      }else{
            this.timeOut = setInterval(()=>{ 
                  console.log('this.$route.path',this.$route.path) 
                  this.$router.go(0);
                  return clearInterval(this.timeOut); 
            },1000*1800)     
      }

    },
    isTimeOut() { 
      document.body.onmouseup = this.throttle(this.handle, 1000);
      document.body.onmousemove = this.throttle(this.handle, 1000); 
      document.body.onkeyup = this.throttle(this.handle, 1000); 
      document.body.onclick = this.throttle(this.handle, 1000); 
      document.body.ontouchend = this.throttle(this.handle, 1000); 
      window.addEventListener('resize', this.throttle(this.handle, 1000)); 
      window.addEventListener('scroll', this.throttle(this.handle, 1000)); 
    }
     
  } 
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue